// import { Axios } from '@/axios/axiosPlugin'
import StationsInfo from '@/pages/main/data/Stations_Info'

// initial state
const state = {

    // main
    display_area: StationsInfo.areas[0],
    display_station: StationsInfo.stations[ StationsInfo.station_order[0] -1 ],//StationsInfo.stations[0],
    stations_info: [],
    area_list: StationsInfo.areas,
    map_tw_countries: undefined, // map boundaries cache: type = json data

    sensor_style: {
        'air_temperature':                 { color: '#ad1f1f', name: '空氣溫度',    unit: '℃',     icon: 'wi wi-thermometer' },
        'air_humidity':                    { color: '#265859', name: '空氣溼度',    unit: '%',      icon: 'wi wi-humidity' },
        'air_pressure':                    { color: '#bf444c', name: '氣壓',        unit: 'hPa',    icon:  'wi wi-hurricane' },

        'wind_speed':                      { color: '#2d862d', name: '風速',        unit: 'm/s',    icon: 'wi wi-strong-wind' },
        'wind_direction':                  { color: '#2d862d', name: '風向',        unit: '',       icon: 'wi wi-strong-wind' },

        'rain_rate':                       { color: '#265859', name: '降雨速率',    unit: 'mm/hr',  icon: 'wi wi-rain' },
        'rainfalls':                       { color: '#265859', name: '累積雨量',    unit: 'mm',     icon: 'wi wi-rain' },

        'solar_radiation':                 { color: '#cc5200', name: '光照',        unit: 'MJ/m2', icon: 'wi wi-sunrise' },
        'dew_point':                       { color: '#ad1f1f', name: '露點',        unit: '℃',     icon: 'wi wi-thermometer' },
        'uvi':                             { color: '#cc5200', name: '指數',        unit: 'UVI',    icon: 'wi wi-solar-eclipse' },

        'soil_temperature':                { color: '#ad1f1f', name: '土壤溫度',    unit: '℃',     icon: 'fas fa-thermometer-half' },
        'soil_moisture':                   { color: '#265859', name: '土壤含水量',  unit: '%',      icon: 'wi wi-humidity' },
        'soil_conductivity':               { color: '#cc5200', name: '土壤電導度',  unit: 'ds/m',   icon: 'wi wi-lightning' },


        'voltage':                         { color: '#cc5200', name: '電壓',        unit: 'V',      icon: 'fas fa-battery-three-quarters' },
        'battery_percentage':              { color: '#cc5200', name: '電量百分比',  unit: '%',      icon: 'fas fa-battery-three-quarters' },
        'voltage_to_battery_percentage':   { color: '#cc5200', name: '電量百分比',  unit: '%',      icon: 'fas fa-battery-three-quarters' },
        'rssi':                            { color: '#bf444c', name: '訊號強度',    unit: 'dBm',    icon: 'fas fa-signal' },
        'snr':                             { color: '#bf444c', name: '訊號雜訊比',  unit: 'dB',     icon: 'fas fa-signal' },
        'rssi_to_signal_bar':              { color: '#bf444c', name: '訊號強度',    unit: '',       icon: 'fas fa-signal' },

        'default':                         { color: '#bf444c', name: '預設',        unit: '',       icon: 'fas fa-rocket' },
    },
}

// getters
const getters = {

    get_SensorIcon: (state) => (sensor_param) => {

        if ( state.sensor_style[ sensor_param ] != undefined )
        {
            return state.sensor_style[ sensor_param ].icon
        }

        return state.sensor_style['default'].icon
    },

    get_SensorColor: (state) => (sensor_param) => {

        if ( state.sensor_style[ sensor_param ] != undefined )
        {
            return state.sensor_style[ sensor_param ].color
        }

        return state.sensor_style['default'].color
    },

    get_SensorName: (state) => (sensor_param) => {

        if ( state.sensor_style[ sensor_param ] != undefined )
        {
            return state.sensor_style[ sensor_param ].name
        }

        return state.sensor_style['default'].name
    },

    get_SensorUnit: (state) => (sensor_param) => {

        if ( state.sensor_style[ sensor_param ] != undefined )
        {
            return state.sensor_style[ sensor_param ].unit
        }

        return state.sensor_style['default'].unit
    },

    get_Rainfall_Tip: (state) => (rainfalls_value) => {

        let _value = parseFloat( rainfalls_value )
        const standard = [
            [ 500, '超大豪雨' ],
            [ 350, '大豪雨' ],
            [ 200, '豪雨' ],
            [ 80, '大雨' ],
            [ 1, '有雨' ],
            [ 0.05, '微雨' ],
            [ 0, '無雨' ],
        ]

        for (let i=0; i < standard.length; i++ )
        {
            if ( _value > standard[ i ][0] ) return standard[ i ][1]
        }
        return ''
    },

    /**
     * get_WindDegree_To_Direction [ 風向(degree)) ] 轉換成 [ 風向(key) ]
     */
    get_WindDegree_To_Direction: (state) => (degree) => {

        let _degree = parseFloat( degree ) % 360 -1  // 減 1 是為了跟儀表板顯示一樣 (因為邊界劃分關係稍微有些不同)
        if ( _degree != undefined )
        {
            if ( _degree < 11.25 ) return 'N'
            if ( _degree < 33.75 ) return 'NNE'
            if ( _degree < 56.25 ) return 'NE'
            if ( _degree < 78.75 ) return 'ENE'
            if ( _degree < 101.25 ) return 'E'
            if ( _degree < 123.75 ) return 'ESE'
            if ( _degree < 146.25 ) return 'SE'
            if ( _degree < 168.75 ) return 'SSE'
            if ( _degree < 191.25 ) return 'S'
            if ( _degree < 213.75 ) return 'SSW'
            if ( _degree < 236.25 ) return 'SW'
            if ( _degree < 258.75 ) return 'WSW'
            if ( _degree < 281.25 ) return 'W'
            if ( _degree < 303.75 ) return 'WNW'
            if ( _degree < 326.25 ) return 'NW'
            if ( _degree < 348.75 ) return 'NNW'
            return 'N'
        }

        return null
    },
}

// actions
const actions = {

}


// mutations
const mutations = {

    reorder_stations (state, data)
    {
        let _reorder_list = []

        StationsInfo.station_order.forEach( _id => {
            _reorder_list.push( StationsInfo.stations[ _id -1 ] )
        })

        state.stations_info = _reorder_list
        state.display_station = _reorder_list[0]
    },

    set_map_tw_countries (state, data)
    {
        state.map_tw_countries = data
    },

    select_station (state, data)
    {
        state.stations_info.forEach( _station => {
            if ( _station.id == data ) state.display_station = _station
        })
    },

    select_area (state, data)
    {
        state.area_list.forEach( _area => {
            if ( _area.toLowerCase() == data.toLowerCase() ) state.display_area = _area
        })
    },

    change_display_farm (state, data)
    {
        state.display_map_farm = data
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
